import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, Typography, Grid, Button, Paper } from '@mui/material';
import axios, {encryptData} from '../../../Axiosinstance';

const CourseDetails = ({ initiative, location, course, language }) => {
  const navigate = useNavigate();
  const [courseDetails, setCourseDetails] = useState([]); // To hold the fetched course details

  // Modify the function to accept the batch id
  const handleBookNowClick = (id) => {
    navigate(`/company/${id}`); // Navigate to the "Company" page with the batch id in the URL
  };

  useEffect(() => {
    // Function to fetch course details from the API
    const fetchCourseDetails = async () => {
      try {
        const response = await axios.get(`/wsq/batches/search`, {
          params: {
            courseName: course,
            categoryName: initiative, // Assuming categoryName corresponds to initiative
            language: language,
            place: location,
          },
        });

        // Set the fetched course details
        if (response.data.length > 0) {
          setCourseDetails(response.data); // Set the array of course details
          console.log(response.data);
        } else {
          console.log("No course details found.");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchCourseDetails(); // Call the fetch function
  }, [initiative, location, course, language]); // Dependencies to trigger fetch

  if (courseDetails.length === 0) {
    return <Typography variant="h6" sx={{ textAlign: 'center', marginTop: '20px' }}>Loading course details...</Typography>;
  }

  return (
    <div>
      {courseDetails.map((courseDetail) => {
        // Destructure courseDetail for easier access
        const { id, name, slotLimit, course: courseInfo, language: courseLanguage, venue, days } = courseDetail;
        
        return (
          <Card
            key={id} // Unique key for each course
            sx={{
              padding: '30px',
              backgroundColor: '#ffffff',
              fontFamily: 'Arial, sans-serif',
              maxWidth: '1200px',
              margin: '20px auto',
              borderRadius: '12px',
              boxShadow: '0 6px 16px rgba(0, 0, 0, 0.1)',
            }}
          >
            <CardContent>
              <Typography variant="h4" gutterBottom sx={{ color: '#333', fontWeight: 'bold', textAlign: 'center' }}>
                {name}
              </Typography>

              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body1" gutterBottom>
                    <strong>Language:</strong> {courseLanguage}
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    <strong>Venue:</strong> {venue.block}, Room No: {venue.roomno}, {venue.place}
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    <strong>Intake Size:</strong> {courseDetail.intakeSize}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={6} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <Paper
                    elevation={3}
                    sx={{
                      padding: '20px',
                      backgroundColor: '#28a745',
                      color: 'white',
                      borderRadius: '10px',
                      textAlign: 'center',
                      width: '100%',
                    }}
                  >
                    <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                      Available Slots
                    </Typography>
                    <Typography variant="h3" sx={{ fontWeight: 'bold', margin: '10px 0' }}>
                      {courseDetail.slotLimit}{/* Display the slot limit */}
                    </Typography>
                    <Typography variant="subtitle1">Slots Available</Typography>
                  </Paper>
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ marginTop: '20px' }}>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" gutterBottom>
                    <strong>Price (Excl. GST):</strong> SGD ${courseInfo.fee}
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                    <strong>Price (Incl. GST):</strong> SGD ${(parseFloat(courseInfo.fee) * 1.09).toFixed(2)} {/* Assuming 7% GST */}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={6} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    sx={{ padding: '12px 0', fontSize: '16px', fontWeight: 'bold', marginBottom: '10px' }}
                    onClick={() => handleBookNowClick(id)} // Pass the batch id when clicking "Book Now"
                  >
                    Book Now
                  </Button>
                  <Button variant="outlined" fullWidth>
                    {true ? 'Show Less' : 'Show More'}
                  </Button>
                </Grid>
              </Grid>

              <Typography variant="h6" gutterBottom sx={{ marginTop: '20px', textAlign: 'center' }}>
                Course Schedule
              </Typography>
              {days.map((day, index )=> (
                <Paper key={day.id} elevation={2} sx={{ padding: '10px', margin: '10px 0' }}>
                  <Typography variant="body2"><strong>Day{index+1}: </strong> {day.date}</Typography>
                  {/* {day.session.map((session, index) => (
                    <Typography key={index} variant="body2">
                      <strong>Session:</strong> {session.session} | 
                      <strong> Start Time:</strong> {session.startTime} | 
                      <strong> End Time:</strong> {session.endTime}
                    </Typography>
                  ))} */}
                </Paper>
              ))}
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};


export default CourseDetails;
